/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
import i18n from './i18n/i18n'
var translate = new Vue({ i18n });

import { RouterTabRoutes } from 'vue-router-tab/lib/index'


Vue.use(store)
Vue.use(Router)

const router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            path: '',
            ...RouterTabRoutes,
            meta: {
                title: 'Testing'
            },
            component: () =>
                import('./layouts/main/Main.vue'),
            children: [
                //----------------------------系统管理----------------------------------
                {
                    path: '/',
                    redirect: '/systemManagement/dashboard',
                    meta: {
                        rolename: 'SM_DASHBOARD',
                        keepAlive: false
                    }
                },
                {
                    path: '/systemManagement/dashboard',
                    name: 'dashboard',
                    component: () =>
                        import(/* webpackChunkName: "system" */'./views/systemManagement/dashboard/dashboard.vue'),
                    meta: {
                        rolename: 'SM_DASHBOARD',
                        title: translate.$t("dashboard"),
                        keepAlive: false
                    }
                },
                {
                    path: '/systemManagement/roles',
                    name: 'roles',
                    component: () =>
                        import(/* webpackChunkName: "system" */'./views/systemManagement/roles/roles.vue'),
                    meta: {
                        rolename: 'SM_ROLE',
                        title: translate.$t("roles"),
                        keepAlive: false
                    }
                },
                {
                    path: '/systemManagement/users',
                    name: 'users',
                    component: () =>
                        import(/* webpackChunkName: "system" */'./views/systemManagement/users/users.vue'),
                    meta: {
                        rolename: 'SM_USER',
                        title: translate.$t("users"),
                        keepAlive: false
                    }
                },
                {
                    path: '/systemManagement/department',
                    name: 'department',
                    component: () =>
                        import(/* webpackChunkName: "system" */'./views/systemManagement/department/department.vue'),
                    meta: {
                        rolename: 'SM_DEPARTMENT',
                        title: translate.$t("department"),
                        keepAlive: false
                    }
                },
                {
                    path: '/systemManagement/teams',
                    name: 'teams',
                    component: () =>
                        import(/* webpackChunkName: "system" */'./views/systemManagement/teams/teams.vue'),
                    meta: {
                        rolename: 'SM_TEAM',
                        title: translate.$t("teams"),
                        keepAlive: false
                    }
                },
                // {
                //     path: '/systemManagement/configurations',
                //     name: 'configurations',
                //     component: () =>
                //         import ('./views/systemManagement/configurations/configurations.vue'),
                //     meta: {
                //         rolename: 'SM_CONFIG'
                //     }
                // },
                //----------------------------商务----------------------------------
                {
                    path: '/business/consumers',
                    name: 'consumers',
                    component: () =>
                        import(/* webpackChunkName: "business" */'./views/business/consumers/consumers.vue'),
                    meta: {
                        rolename: 'BIZ_CUSTOMER',
                        title: translate.$t("consumers"),
                        keepAlive: false
                    }
                },
                {
                    path: '/business/providers',
                    name: 'providers',
                    component: () =>
                        import(/* webpackChunkName: "business" */'./views/business/providers/providers.vue'),
                    meta: {
                        rolename: 'BIZ_PROVIDER',
                        title: translate.$t("providers"),
                        keepAlive: false
                    }
                },
                //----------------------------项目管理----------------------------------
                {
                    path: '/projectManagement/projects',
                    name: 'projects',
                    component: () =>
                        import(/* webpackChunkName: "project" */'./views/projectManagement/projects.vue'),
                    meta: {
                        title: translate.$t("projects"),
                        keepAlive: false
                    }
                },
                {
                    path: '/projectManagement/purchaseOrders',
                    name: 'purchaseOrders',
                    component: () =>
                        import('./views/projectManagement/purchaseOrders.vue')
                },
                {
                    path: '/projectManagement/contracts',
                    name: 'contracts',
                    component: () =>
                        import('./views/projectManagement/contracts.vue')
                },
                {
                    path: '/projectManagement/projectGraph',
                    name: 'projectGraph',
                    component: () =>
                        import('./views/projectManagement/projectGraph.vue')
                },
                //----------------------------知识库----------------------------------
                {
                    path: '/knowledge/knowledge',
                    name: 'Knowledge',
                    component: () => import('./views/knowledge/knowledge.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT',
                        title: translate.$t("knowledge"),
                        keepAlive: false
                    }
                },
                //----------------------------资产管理----------------------------------
                {
                    path: '/assetsManagement/overview',
                    name: 'overview',
                    component: () =>
                        import(/* webpackChunkName: "assetOverview" */'./views/assetsManagement/overview/overview.vue'),
                    meta: {
                        rolename: 'ASSET_HARDWARE',
                        title: translate.$t("overview"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetsManagement/hardware',
                    name: 'hardware',
                    component: () =>
                        import(/* webpackChunkName: "hardware" */'./views/assetsManagement/hardware/hardware.vue'),
                    meta: {
                        rolename: 'ASSET_HARDWARE',
                        title: translate.$t("hardware"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetsManagement/software',
                    name: 'software',
                    component: () =>
                        import(/* webpackChunkName: "asset" */'./views/assetsManagement/software/software.vue'),
                    meta: {
                        rolename: 'ASSET_SOFTWARE',
                        title: translate.$t("software"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetsManagement/software/carrier',
                    name: 'carrier',
                    component: () =>
                        import(/* webpackChunkName: "hardware" */'./views/assetsManagement/software/components/carrier.vue'),
                    meta: {
                        rolename: 'ASSET_SOFTWARE',
                        title: translate.$t("carrier"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetsManagement/zone',
                    name: 'zone',
                    component: () =>
                        import(/* webpackChunkName: "asset" */'./views/assetsManagement/zone/zone.vue'),
                    meta: {
                        rolename: 'ASSET_ZONE',
                        title: translate.$t("zone"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetsManagement/type',
                    name: 'type',
                    component: () =>
                        import(/* webpackChunkName: "asset" */'./views/assetsManagement/type/type.vue'),
                    meta: {
                        rolename: 'ASSET_TYPE',
                        title: translate.$t("type"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetsManagement/license',
                    name: 'license',
                    component: () =>
                        import(/* webpackChunkName: "asset" */'./views/assetsManagement/license/license.vue'),
                    meta: {
                        rolename: 'ASSET_LICENSE',
                        title: translate.$t("license"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetsManagement/hardwareDetail',
                    name: 'hardwareDetail',
                    component: () =>
                        import(/* webpackChunkName: "asset" */'./views/assetsManagement/hardware/hardwareDetail.vue'),
                    meta: {
                        rolename: 'ASSET_HARDWARE',
                        title: translate.$t("hardwareDetail"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetsManagement/readProperties',
                    name: 'readProperties',
                    component: () =>
                        import(/* webpackChunkName: "asset" */'./views/assetsManagement/hardware/component/readProperties.vue'),
                    meta: {
                        rolename: 'ASSET_HARDWARE',
                        title: translate.$t("print"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetsManagement/QR',
                    name: 'QR',
                    component: () =>
                        import(/* webpackChunkName: "asset" */'./views/assetsManagement/QR.vue'),
                    meta: {
                        rolename: 'ASSET_HARDWARE',
                        title: translate.$t("qr"),
                        keepAlive: false
                    }
                },
                //----------------------------访客管理----------------------------------
                {
                    path: '/visitorsManage/verifyVisitors',
                    name: 'verifyVisitors',
                    component: () =>
                        import('./views/visitorsManage/verifyVisitors.vue'),
                    meta: {
                        title: translate.$t("verifyVisitors")
                    }
                },
                {
                    path: '/visitorsManage/visitorsRequest',
                    name: 'visitorsRequest',
                    component: () =>
                        import('./views/visitorsManage/visitorsRequest.vue'),

                },
                //----------------------------工单系统----------------------------------
                {
                    path: '/ticketSystem/helpdesk',
                    name: 'helpdesk',
                    component: () =>
                        import(/* webpackChunkName: "ticket" */'./views/ticketSystem/applyTicket/helpdesk.vue'),
                    meta: {
                        rolename: 'APPLY_TICKET',
                        title: translate.$t("helpdesk"),
                        keepAlive: false
                    }
                },
                {
                    path: '/ticketSystem/workOrderDetails',
                    name: 'workOrderDetails',
                    component: () =>
                        import(/* webpackChunkName: "ticket" */'./views/ticketSystem/applyTicket/detail/workOrderDetails.vue'),
                    meta: {
                        rolename: 'APPLY_TICKET',
                        title: translate.$t("ticketDetails"),
                        keepAlive: false
                    }
                },
                {
                    path: '/ticketSystem/kpi',
                    name: 'kpi',
                    component: () =>
                        import(/* webpackChunkName: "ticket" */'./views/ticketSystem/userPerformance/performance.vue'),
                    meta: {
                        rolename: 'APPLY_TICKET',
                        title: translate.$t("kpi"),
                        keepAlive: false
                    }
                },
                {
                    path: '/ticketSystem/ticketSupport/:id',
                    name: 'ticketSupport',
                    component: () =>
                        import(/* webpackChunkName: "ticket" */'./views/ticketSystem/ticketSupport/ticketSupport.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT',
                        title: translate.$t("ticketSupport"),
												keepAlive: false
                    }
                },
                {
                    path: '/ticketSystem/ticketSupport/:id/:ticket',
                    name: 'ticketDetails',
                    component: () =>
                        import(/* webpackChunkName: "ticket" */'./views/ticketSystem/ticketSupport/ticketDetails/detail.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT',
                        title: translate.$t("ticketExamine"),
                        keepAlive: false
                    }
                },
                {
                    path: '/ticketSystem/ticketSupport/:id/:ticket/:information',
                    name: 'ticketInformation',
                    component: () =>
                        import(/* webpackChunkName: "ticket" */'./views/ticketSystem/ticketSupport/ticketDetails/ticketInformation.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT',
                        title: translate.$t("ticketInformation"),
                        keepAlive: false
                    }
                },
                {
                    path: '/ticketSystem/assetTicketSupport',
                    name: 'ticketSupport',
                    component: () =>
                        import(/* webpackChunkName: "ticket" */'./views/ticketSystem/ticketSupport/assetTicketSupport/assetTicketSupport.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT',
                        title: translate.$t("ticketSupport"),
                        keepAlive: false
                    }
                },
                {
                    path: '/ticketSystem/ticketOverview',
                    name: 'ticketOverview',
                    component: () =>
                        import(/* webpackChunkName: "ticket" */'./views/ticketSystem/overview/overview.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT',
                        title: translate.$t("ticketOverview"),
                        keepAlive: false
                    }
                },
								{
									path: '/ticketSystem/ticketPersonal',
									name: 'ticketPersonal',
									component: () =>
											import(/* webpackChunkName: "ticket" */'./views/ticketSystem/ticketPersonal/ticketPersonal.vue'),
									meta: {
											rolename: 'TICKET_PERSONAL',
											title: translate.$t("ticketPersonal"),
											keepAlive: false
									}
								},
								{
									path: '/ticketSystem/ticketRanked',
									name: 'ticketRanked',
									component: () =>
											import(/* webpackChunkName: "ticket" */'./views/ticketSystem/overview/ticketRanked.vue'),
									meta: {
											rolename: 'TICKET_RANKED',
											title: translate.$t("ticketRanked"),
											keepAlive: false
									}
								},
                {
                    path: '/ticketSystem/ticketConfiguration',
                    name: 'ticketConfiguration',
                    component: () =>
                        import(/* webpackChunkName: "ticket" */'./views/ticketSystem/configuration/ticketConfiguration.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG',
                        title: translate.$t("ticketConfiguration"),
                        keepAlive: false
                    }
                },
                {
                    path: '/projects/projectManagement',
                    name: 'Projects',
                    component: () => import(/* webpackChunkName: "project" */'./views/projects/projects.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG',
                        title: translate.$t("projectManagement"),
                        keepAlive: false
                    }
                },
                {
                    path: '/projects/projectSetting',
                    name: 'projectSetting',
                    component: () => import(/* webpackChunkName: "project" */'./views/projects/projectSetting.vue'),
                    meta: {
                        rolename: 'PROJECT_SETTING',
                        title: translate.$t("projectSet"),
                        keepAlive: false
                    }
                },
                {
                    path: '/projects/projectDocuments',
                    name: 'projectDocuments',
                    component: () => import(/* webpackChunkName: "project" */'./views/projects/projectDocuments.vue'),
                    meta: {
                        rolename: 'PROJECT_DOCUMENTS',
                        title: translate.$t("projectDoc"),
                        keepAlive: false
                    }
                },
                {
                    path: '/projects/projectManagement/create',
                    name: 'create-project',
                    component: () =>
                        import(/* webpackChunkName: "project" */'./views/projects/create-project.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG',
                        title: translate.$t("createProject"),
                        keepAlive: false
                    }
                },
                // {
                //     path: '/ticketSystem/ticketConfiguration',
                //     name: 'ticketConfiguration',
                //     component: () =>
                //         import ('./views/ticketSystem/configuration/ticketConfiguration/configuration.vue'),
                //         meta: {
                //             rolename: 'TICKET_CONFIG'
                //         }
                // },
                // {
                //     path: '/ticketSystem/ticketConfiguration/typeManagement',
                //     name: 'ticketConfiguration',
                //     component: () =>
                //         import ('./views/ticketSystem/configuration/typeManagement/typeManagement.vue'),
                //         meta: {
                //             rolename: 'TICKET_CONFIG'
                //         }
                // },
                {
                    path: '/assetInspection/template',
                    name: 'template',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/templates/templateListing.vue'),
                    meta: {
                        rolename: 'TEMPLATE_CONFIG',
                        title: translate.$t("template"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetInspection/template/:id',
                    name: 'templateDetail',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/templates/templateDetail.vue'),
                    meta: {
                        rolename: 'TEMPLATE_CONFIG',
                        title: translate.$t("templateDetail"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetInspection/task',
                    name: 'scheduleListing',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/schedule/scheduleListing.vue'),
                    meta: {
                        rolename: 'SCHEDULE_CONFIG',
                        title: translate.$t("schedule"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetInspection/task/:id',
                    name: 'scheduleDetail',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/schedule/scheduleDetail.vue'),
                    meta: {
                        rolename: 'SCHEDULE_CONFIG',
                        title: translate.$t("taskDetail")
                    }
                },
                {
                    path: '/assetInspection/plan/import/:id',
                    name: 'import',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/schedule/import.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG',
                        title: translate.$t("assetImport")
                    }
                },
                {
                    path: '/assetInspection/todo',
                    name: 'inspectionListing',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/inspection/inspectionListing.vue'), // inspectionListing1
                    meta: {
                        rolename: 'TICKET_SUPPORT', // INSPECTION_CONFIG
                        title: translate.$t("task"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetInspection/inspector',
                    name: 'inspectionListing',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/inspection/Inspector.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT', 
                        title: translate.$t("monthView")
                    }
                },
                {
                    path: '/assetInspection/week',
                    name: 'inspectionListing',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/inspection/InspectorWeekView.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT', 
                        title: translate.$t("weekView")
                    }
                },
                {
                    path: '/assetInspection/exception',
                    name: 'inspectionListing',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/inspection/ExceptionReport.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT', 
                        title: translate.$t("exceptionReport")
                    }
                },
                {
                    path: '/assetInspection/myInspection',
                    name: 'inspectionListing',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/inspection/MyInspection.vue'),
                    meta: {
                        rolename: 'TICKET_SUPPORT', 
                        title: translate.$t("myInspection")
                    }
                },
                {
                    path: '/assetInspection/table',
                    name: 'inspectionListing',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/inspection/table.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG',
                        title: translate.$t("table")
                    }
                },
                {
                    path: '/assetInspection/report',
                    name: 'reportListing',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/report/reportListing.vue'),
                    meta: {
                        rolename: 'REPORT_CONFIG',
                        title: translate.$t("InspectionReports"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetInspection/report/:id',
                    name: 'report',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/report/report.vue'),
                    meta: {
                        rolename: 'REPORT_CONFIG',
                        title: translate.$t("InspectionReport"),
                        keepAlive: false
                    }
                },
                {
                    path: '/assetInspection/todo/:id',
                    name: 'inspectionListing',
                    component: () =>
                        import(/* webpackChunkName: "inspection" */'./views/assetInspection/inspection/inspectionDetail.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG',
                        title: translate.$t("inspectionTask"),
                        keepAlive: false
                    }
                },
                {
                    path: '/monitorSystem/overview',
                    name: 'overview',
                    component: () =>
                        import(/* webpackChunkName: "monitor" */'./views/monitorSystem/overview/overview.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG',
                        title: translate.$t("overview"),
                        keepAlive: false
                    }
                },
                {
                    path: '/monitorSystem/monitor',
                    name: 'monitor',
                    component: () =>
                        import(/* webpackChunkName: "monitor" */'./views/monitorSystem/monitor/monitor.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG',
                        title: translate.$t("monitor"),
                        keepAlive: false
                    }
                },
                {
                    path: '/monitorSystem/addMontitor',
                    name: 'addMontitor',
                    component: () =>
                        import(/* webpackChunkName: "monitor" */'./views/monitorSystem/monitor/addMontitor/addMontitor.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG',
                        title: translate.$t("monitor"),
                        keepAlive: false
                    }
                },
                {
                    path: '/monitorSystem/monitorDetail',
                    name: 'monitorDetail',
                    component: () =>
                        import(/* webpackChunkName: "monitor" */'./views/monitorSystem/monitor/monitorDetail/monitorDetail.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG'
                    }
                },
                //----------------------------profile--------------------------------
                {
                    path: '/pages/services',
                    name: 'services',
                    component: () =>
                        import(/* webpackChunkName: "user" */'@/views/pages/services.vue'),
                    meta: {
                        noRequireAuth: true,
                        title: translate.$t("services"),
                        keepAlive: false
                    }
                },
                {
                    path: '/pages/profile',
                    name: 'page-profile',
                    component: () =>
                        import(/* webpackChunkName: "user" */'@/views/pages/Profile.vue'),
                    meta: {
                        noRequireAuth: true,
                        title: translate.$t("profile"),
                        keepAlive: false
                    }
                    // meta: {
                    //     breadcrumb: [
                    //         { title: 'Home', url: '/' },
                    //         { title: 'Pages' },
                    //         { title: 'Profile', active: true },
                    //     ],
                    //     pageTitle: 'Profile',
                    //     rule: 'editor'
                    // },
                },
                {
                    path: '/pages/companyinfo',
                    name: 'page-companyinfo',
                    component: () =>
                        import(/* webpackChunkName: "user" */'@/views/pages/companyinfo.vue'),
                    meta: {
                        noRequireAuth: true,
                        title: translate.$t("companyInfo"),
                        keepAlive: false
                    }
                    // meta: {
                    //     breadcrumb: [
                    //         { title: 'Home', url: '/' },
                    //         { title: 'Pages' },
                    //         { title: 'company info', active: true },
                    //     ],
                    //     pageTitle: 'companyinfo',
                    //     rule: 'editor'
                    // },
                },
            ],
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () =>
                import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/pages/login',
                    name: 'page-login',
                    component: () =>
                        import(/* webpackChunkName: "auth" */'@/views/pages/Login.vue'),
                    meta: {
                        noRequireAuth: true,
                    },
                },
                {
                    path: '/pages/projectManagement/:id',
                    name: 'Project',
                    component: () => import(/* webpackChunkName: "project" */'./views/projects/detail.vue'),
                    meta: {
                        rolename: 'TICKET_CONFIG'
                    }
                },
                {
                    path: '/pages/register',
                    name: 'page-register',
                    component: () =>
                        import(/* webpackChunkName: "auth" */'@/views/pages/register/Register.vue'),
                    meta: {
                        rule: 'editor',
                        noRequireAuth: true,
                    }
                },
                {
                    path: '/pages/forgot-password',
                    name: 'page-forgot-password',
                    component: () =>
                        import(/* webpackChunkName: "forgotPassword" */'@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'editor',
                        noRequireAuth: true,
                    }
                },
                {
                    path: '/pages/reset-password',
                    name: 'page-reset-password',
                    component: () =>
                        import(/* webpackChunkName: "changePassword" */'@/views/pages/ChangePassword.vue'),
                    meta: {
                        rule: 'editor',
                        noRequireAuth: true,
                    }
                },
                {
                    path: '/pages/landing',
                    name: 'page-landing',
                    component: () =>
                        import(/* webpackChunkName: "landing" */'@/views/pages/landing.vue'),
                    meta: {
                        rule: 'editor',
                        noRequireAuth: true,
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () =>
                        import(/* webpackChunkName: "notFound" */'@/views/pages/Error404.vue'),
                    meta: {
                        noRequireAuth: true,
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})
router.beforeEach((to, from, next) => {

    if (store.state.disableClick) {
        store.commit('UPDATE_CLICK', false)
    }
    if (to.meta.noRequireAuth) {
        next();
    } else {
        let pathname = to.meta.rolename;
        let roles = store.state.AppUser.access
        let token = ''
        if (store.state.AppUser.token) {
            token = store.state.AppUser.token
        } else {
            token = localStorage.token
            store.commit('UPDATE_USER_INFO', { token: token });
        }
        if (token&&store.state.AppUser.accountNo) {
					next();
            // if (roles[pathname]) {
                // if (roles[pathname].charAt(0) == "1") {
                //     next();
                // } else {
                    // next('/pages/error-404')
                // }
            // } else {
            //     next('/pages/error-404')
            // }
        } else {
            next('/pages/landing')
        }

    }
})
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg');
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router